// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import myAccountFilterSectionStyles from "@flip/App/SharedStyle/MyAccount/List/MyAccountFilterSectionStyles";
import { mergeWithCss } from "@flip/XDL/Utilities";
import { rfqMyQuotesHeaderStyles } from "@insite/content-library/Widgets/RfqMyQuotes/RfqMyQuotesHeader";
import { css } from "styled-components";

rfqMyQuotesHeaderStyles.container = {
    gap: 8,
    css: css`
        margin-bottom: 0;
    `,
};

rfqMyQuotesHeaderStyles.quoteCountGridItem = {
    ...myAccountFilterSectionStyles.countGridItem,
};

rfqMyQuotesHeaderStyles.toggleFilterGridItem = {
    ...mergeWithCss(myAccountFilterSectionStyles.toggleFilterGridItem, {
        css: css`
            button {
                ${myAccountFilterSectionStyles.toggleFilterClickable?.css}
            }
        `,
    }),
};

rfqMyQuotesHeaderStyles.toggleFilterButton = {
    ...myAccountFilterSectionStyles.toggleFilterButton,
};

rfqMyQuotesHeaderStyles.statusFilterGridItem = {
    width: 12,
    css: css`
        & > div {
            max-width: 320px;
            margin-bottom: 18px;
        }
    `,
};

rfqMyQuotesHeaderStyles.typeFilterGridItem = {
    width: 12,
    css: css`
        & > div {
            max-width: 320px;
            margin-bottom: 18px;
        }
    `,
};
